import {I18n} from '@aws-amplify/core';
import {SimplePageHeader} from '@flexinet/ui-components';

import {FilterRecordsButton} from '../buttons/FilterRecordsButton.tsx';
import {ReloadRecordsButton} from '../buttons/ReloadRecordsButton.tsx';
import config from '../config';

const useTools = () => {
    // No Add / Edit / Delete. Defect signatures are PRODUCED by the triage sweep
    // from observed evidence — a human authoring one by hand would create a
    // fingerprint that matches nothing. Filter + Reload only; the triage actions
    // (acknowledge, file) live on the individual defect, where the evidence is.
    return [
        <FilterRecordsButton key='filter'/>,
        <ReloadRecordsButton key='reload'/>,
    ];
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get(config.titles.plural)}
            tools={useTools()}
        />
    );
};
